import * as React from 'react'
import styled from 'styled-components'
import { StoreProps } from 'src/stores'
import { inject, observer } from 'mobx-react'
import { withRouter } from 'react-router-dom'
import { FamilyStatus, GreetingType, MandateForm, ReligionType } from 'src/resources'
import Signature from 'src/components/molecules/warrant/SignatureCanvas'
import Dropdown from 'src/components/atoms/input/Dropdown'
import { TInput } from 'src/components/atoms/input/TextInput'
import LargeModal from 'src/components/containers/LargeModal'
import { StartBtn, TranspBtn } from 'src/components/atoms/input/buttons'
import FeedbackText from 'src/components/atoms/FeedbackText'
import { media } from '../../../utils'

interface Props extends StoreProps {
  location: any
  history: any
  match: any
  clever: any
}

interface State {
  dataUrl: string
  openModal: boolean
  d_greeting: GreetingType
  d_firstname: string
  d_lastname: string
  d_familystatus: FamilyStatus
  d_placebirth: string
  d_datebirth: string
  d_datedeath: string
  d_religion: ReligionType
  d_lastaddress: string
  greeting: GreetingType
  firstname: string
  lastname: string
  dateofbrith: string
  relation: string
  address: string
  date: string
  place: string
  showErrors: boolean
  showProcessingErrors: boolean
  submitText: string
}

@inject('confStore')
@observer
export class WarrantForm extends React.Component<Props, State> {
  constructor(props) {
    super(props)
    this.state = {
      dataUrl: null,
      openModal: false,
      d_firstname: '',
      d_lastname: '',
      d_familystatus: null,
      d_greeting: null,
      d_datebirth: '',
      d_religion: null,
      d_placebirth: '',
      d_datedeath: '',
      d_lastaddress: '',
      greeting: null,
      firstname: '',
      lastname: '',
      dateofbrith: '',
      relation: '',
      address: '',
      date: '',
      place: '',
      showErrors: false,
      showProcessingErrors: false,
      submitText: 'Abschicken'
    }
  }

  componentDidMount() {
    const { confStore, match } = this.props
    if (match.params.uuid && !confStore.isOfferLoaded)
      confStore.findOfferByUuid(match.params.uuid)
  }

  validateString = (str: string) => {
    return str && str.length >= 2
  }

  validForm = () => {

    const {
      dataUrl,
      d_greeting,
      d_firstname,
      d_lastaddress,
      d_lastname,
      d_datebirth,
      d_familystatus,
      d_religion,
      d_placebirth,
      firstname,
      lastname,
      greeting,
      relation,
      address,
      dateofbrith,
      place,
    } = this.state
    // console.log(d_religion);
    return !!(
      dataUrl &&
      d_greeting &&
      this.validateString(d_firstname) &&
      this.validateString(d_lastname) &&
      this.validateString(d_lastaddress) &&
      d_familystatus &&
      this.validateString(d_datebirth) &&
      d_religion &&
      this.validateString(d_placebirth) &&
      this.validateString(firstname) &&
      this.validateString(lastname) &&
      greeting &&
      this.validateString(relation) &&
      this.validateString(address) &&
      this.validateString(dateofbrith) &&
      this.validateString(place)
    )
  }

  openModal = () => {
    // calculate dimensions
    this.setState({ openModal: true })
  }

  handleSignatureConfirm = (s) => {
    if (s) {
      this.setState({ dataUrl: s, openModal: false })
    }
  }

  submitForm = (e) => {
    e.preventDefault()
    if (this.validForm()) {
      const { confStore, history, clever } = this.props
      const {
        dataUrl,
        d_greeting,
        d_firstname,
        d_lastaddress,
        d_lastname,
        d_datebirth,
        d_datedeath,
        d_familystatus,
        d_religion,
        d_placebirth,
        firstname,
        lastname,
        greeting,
        relation,
        address,
        dateofbrith,
        place
      } = this.state
      const form: MandateForm = {
        deceased_greeting: d_greeting,
        deceased_firstname: d_firstname,
        deceased_lastname: d_lastname,
        deceased_lastAddress: d_lastaddress,
        deceased_dateOfBirth: d_datebirth,
        deceased_dateOfDeath: d_datedeath,
        deceased_familiyStatus: d_familystatus,
        deceased_religionType: d_religion,
        deceased_placeOfBirth: d_placebirth,
        customer_greeting: greeting,
        customer_firstname: firstname,
        customer_lastname: lastname,
        customer_dateOfBirth: dateofbrith,
        customer_relation: relation,
        customer_address: address,
        place,
        signature: dataUrl,
        clever: clever
      }
      this.setState({ submitText: 'Lädt...', showErrors: false })
      confStore.sendWarrant(form).then((url) => {
        if (url) {
          let targetUrl = this.props.clever ? '/clever/danke/vollmacht/' : '/danke/vollmacht/'
          if (confStore.isOfferLoaded) {
            history.push(`${targetUrl}${confStore.getOffer.uuid}`)
          } else {
            history.push(targetUrl)
          }
        } else {
          this.setState({
            showProcessingErrors: true,
            submitText: 'Abschicken'
          })
        }
      })
    } else {
      this.setState({ showErrors: true })
    }
  }

  render() {
    const { confStore, match, history, clever } = this.props
    const {
      dataUrl,
      openModal,
      d_greeting,
      d_firstname,
      d_lastaddress,
      d_lastname,
      d_datebirth,
      d_datedeath,
      d_familystatus,
      d_placebirth,
      d_religion,
      firstname,
      lastname,
      greeting,
      relation,
      address,
      dateofbrith,
      showErrors,
      showProcessingErrors,
      place,
      submitText
    } = this.state

    if(clever){
      colorStyles = {
        'border': '#FBB07F',
        'borderError': '#974154',
        'bg': '#FDD7BF',
        'buttonBg': '#040a31',
        'buttonDisabled': '#040a3199'
      }
    }

    if (match.params.uuid && !confStore.isOfferLoaded) {
      return (
        <Container>
          <h1 style={{ textAlign: 'center' }}>Lädt...</h1>
        </Container>
      )
    }

    if (confStore.getMandateDownloadUrl()) {
      history.push(`/danke/vollmacht/${confStore.getOffer.uuid}`)
    }

    const deceased_genders = [
      { value: 'Herr', key: 'MR', selected: d_greeting === 'MR' },
      { value: 'Frau', key: 'MRS', selected: d_greeting === 'MRS' }
    ]
    const religions_type = [
      {value: "Christlich (römisch-katholisch)", key:'CHRISTIAN_ROMAN_CATHOLIC', selected: d_religion === 'CHRISTIAN_ROMAN_CATHOLIC'},
      {value: "Christlich (evangelisch)", key:'CHRISTIAN_EVANGELICAL' , selected: d_religion === 'CHRISTIAN_EVANGELICAL' },
      {value: "Christlich (orthodox)", key:'CHRISTIAN_ORTHODOX' , selected: d_religion === 'CHRISTIAN_ORTHODOX' },
      {value: "Muslimisch", key:'MUSLIM' , selected: d_religion === 'MUSLIM' },
      {value: "Buddhistisch", key:'BUDDHIST' , selected: d_religion === 'BUDDHIST' },
      {value: "Jüdisch", key:'JEWISH' , selected: d_religion === 'JEWISH' },
      {value: "Hindu", key:'HINDU' , selected: d_religion === 'HINDU' },
      {value: "Sikh", key:'SIKH', selected: d_religion === 'SIKH'},
      {value: "Ohne Bekenntnis", key:'WITHOUT_CONFESSION', selected: d_religion === 'WITHOUT_CONFESSION'},
      {value: "Andere", key:'OTHERS', selected: d_religion === 'OTHERS'}
    ]

    const customer_genders = [
      { value: 'Herr', key: 'MR', selected: greeting === 'MR' },
      { value: 'Frau', key: 'MRS', selected: greeting === 'MRS' }
    ]

    const familystatus = [
      { value: 'ledig', key: 'SINGLE', selected: d_familystatus === 'SINGLE' },
      {
        value: 'verheiratet',
        key: 'MARRIED',
        selected: d_familystatus === 'MARRIED'
      },
      {
        value: 'geschieden',
        key: 'DIVORCED',
        selected: d_familystatus === 'DIVORCED'
      },
      {
        value: 'verwitwet',
        key: 'WIDOWED',
        selected: d_familystatus === 'WIDOWED'
      }
    ]
    return (
      <Container>
        <h1>Bestattungs&shy;vollmacht</h1>
        <p>
          Für die vollumfängliche Organistion der Bestattung und um Sie in allen
          Formalitäten (z.B. Krankenhäusern, Friedhöfen, etc.) vertreten zu
          können, bitten wir Sie um die Erteilung einer Bestattungsvollmacht.
        </p>
        <p>
          <strong>Die Vollmacht dient zur Regelung der Bestattung von:</strong>
        </p>
        <Grid>
          <Dropdown
            items={deceased_genders}
            placeholder='Anrede'
            onSelect={(e) => this.setState({ d_greeting: e.target.value })}
            valid={showErrors ? !!d_greeting : true}
            clever={clever}
          />
          <WarrantTextInput
            name='d_firstname'
            placeholder='Vorname'
            value={d_firstname}
            onChange={(e) => this.setState({ d_firstname: e.target.value })}
            valid={showErrors ? this.validateString(d_firstname) : true}
            clever={clever}
          />
          <WarrantTextInput
            name='d_lastname'
            placeholder='Nachname'
            value={d_lastname}
            onChange={(e) => this.setState({ d_lastname: e.target.value })}
            valid={showErrors ? this.validateString(d_lastname) : true}
            clever={clever}
          />
          <Dropdown
            items={familystatus}
            placeholder='Familienstand'
            onSelect={(e) => this.setState({ d_familystatus: e.target.value })}
            valid={showErrors ? !!d_familystatus : true}
            clever={clever}
          />
          <WarrantTextInput
            name='d_place_of_birth'
            placeholder='Geburtsort'
            value={d_placebirth}
            onChange={(e) => this.setState({ d_placebirth: e.target.value })}
            valid={showErrors ? this.validateString(d_placebirth) : true}
            clever={clever}
          />
          <WarrantTextInput
            placeholder='Geburtsdatum'
            value={d_datebirth}
            onChange={(e) => this.setState({ d_datebirth: e.target.value })}
            valid={showErrors ? this.validateString(d_datebirth) : true}
            clever={clever}
          />
          <WarrantTextInput
            placeholder='Sterbedatum'
            date={d_datedeath}
            onChange={(e) => this.setState({ d_datedeath: e.target.value })}
          />
          <Dropdown
            items={religions_type}
            placeholder='Religionsbekenntnis'
            onSelect={(e) => this.setState({ d_religion: e.target.value })}
          />
          <WarrantTextInput
            name='last_address'
            placeholder='Letzter Wohnsitz (Anschrift)'
            value={d_lastaddress}
            onChange={(e) => this.setState({ d_lastaddress: e.target.value })}
            valid={showErrors ? this.validateString(d_lastaddress) : true}
          />
        </Grid>
        {
          this.props.clever ?
          <p>
          Ich erteile hiermit CLEVER Bestattung (einer Marke der Benu GmbH),
          Siebenbrunnengasse 9, 1050 Wien, Vollmacht, mich im Zusammenhang
          mit der beauftragten Bestattung vollumfänglich zu vertreten und zu diesem
          Zweck insbesondere auch Verträge mit Dritten wie Behörden, Gemeinden, Pfarren,
          Friedhöfen, Krematorien, Trauersprechern, Steinmetzen und dgl. in meinem
          Namen und allenfalls auf meine Rechnung abzuschließen, Schriftstücke
          einschließlich Sterbeurkunde, Einäscherungsbestätigung und dgl. zu übernehmen
          sowie Stellvertreter mit gleicher oder eingeschränkter Vollmacht zu bestellen.
          Außerdem ist die GmbH durch die Vollmacht berechtigt Untervollmachten für Personen,
          die nicht direkt handlungsbevollmächtigt sind, auszustellen.
        </p> :
            <p>
              Ich erteile hiermit der Firma Benu GmbH,
              Siebenbrunnengasse 9, 1050 Wien, Vollmacht, mich im Zusammenhang
              mit der beauftragten Bestattung vollumfänglich zu vertreten und zu diesem
              Zweck insbesondere auch Verträge mit Dritten wie Behörden, Gemeinden, Pfarren,
              Friedhöfen, Krematorien, Trauersprechern, Steinmetzen und dgl. in meinem
              Namen und allenfalls auf meine Rechnung abzuschließen, Schriftstücke
              einschließlich Sterbeurkunde, Einäscherungsbestätigung und dgl. zu übernehmen
              sowie Stellvertreter mit gleicher oder eingeschränkter Vollmacht zu bestellen.
              Außerdem ist die GmbH durch die Vollmacht berechtigt Untervollmachten für Personen,
              die nicht direkt handlungsbevollmächtigt sind, auszustellen.
            </p>
        }
        {
          this.props.clever ?
            <p>
          Ich nehme hiermit zur Kenntnis, dass im Rahmen der Organisation der Bestattung
          personenbezogene Daten (Anrede, Vorname, Nachname, Wohnanschrift, Geburtsdatum,
          Telefonnummer, Verwandtschaftsgrad) an die jeweiligen für die Vertragserfüllung
          herangezogenen Partner übermittelt werden. Grundlage für diese Datenverarbeitung
          ist Art 6 Abs 1 lit b DSGVO. CLEVER Bestattung löscht Ihre personenbezogenen Daten,
          sobald CLEVER Bestattung diese für die Erbringung und Abrechnung der Bestattungsdienstleistungen
          nicht mehr benötigt.
        </p> :
            <p>
              Ich nehme hiermit zur Kenntnis, dass im Rahmen der Organisation der Bestattung
              personenbezogene Daten (Anrede, Vorname, Nachname, Wohnanschrift, Geburtsdatum,
              Telefonnummer, Verwandtschaftsgrad) an die jeweiligen für die Vertragserfüllung
              herangezogenen Partner übermittelt werden. Grundlage für diese Datenverarbeitung
              ist Art 6 Abs 1 lit b DSGVO. Benu Bestattung löscht Ihre personenbezogenen Daten,
              sobald Benu Bestattung diese für die Erbringung und Abrechnung der Bestattungsdienstleistungen
              nicht mehr benötigt.
            </p>
        }
        <p>
          Die Zustimmung zur Datenverarbeitung ist jederzeit widerrufbar, wobei ein Widerruf 
          die Auflösung und Rückabwicklung des Vertrages zur Folge haben kann.
        </p>
        <p>
          <strong>Auftraggeber / Vollmachtgeber</strong>
        </p>
        <GridBottom>
          <Dropdown
            items={customer_genders}
            placeholder='Anrede'
            onSelect={(e) => this.setState({ greeting: e.target.value })}
            valid={showErrors ? !!greeting : true}
            
          />
          <WarrantTextInput
            name='firstname'
            placeholder='Vorname'
            value={firstname}
            onChange={(e) => this.setState({ firstname: e.target.value })}
            valid={showErrors ? this.validateString(firstname) : true}
          />
          <WarrantTextInput
            name='lastname'
            placeholder='Nachname'
            value={lastname}
            onChange={(e) => this.setState({ lastname: e.target.value })}
            valid={showErrors ? this.validateString(lastname) : true}
          />
          <WarrantTextInput
            placeholder='Geburtsdatum'
            date={dateofbrith}
            onChange={(e) => this.setState({ dateofbrith: e.target.value })}
            valid={showErrors ? this.validateString(dateofbrith) : true}
          />
          <WarrantTextInput
            name='relation'
            placeholder='Verhältnis zum Verstorbenen'
            value={relation}
            onChange={(e) => this.setState({ relation: e.target.value })}
            valid={showErrors ? this.validateString(relation) : true}
          />
          <WarrantTextInput
            name='address'
            placeholder='Anschrift'
            value={address}
            onChange={(e) => this.setState({ address: e.target.value })}
            valid={showErrors ? this.validateString(address) : true}
          />
        </GridBottom>
        <p>
          <strong>Unterzeichnung:</strong>
        </p>
        <SignatureGrid>
          <WarrantTextInput
            name='place'
            placeholder='Ort'
            value={place}
            onChange={(e) => this.setState({ place: e.target.value })}
            valid={showErrors ? this.validateString(place) : true}
          />
          <FormSignatureContainer
            signed={!!dataUrl}
            valid={showErrors ? !!dataUrl : true}>
            {dataUrl && <img src={dataUrl} />}
            <a onClick={this.openModal} style={{ cursor: 'pointer' }}>
              {dataUrl ? 'ändern' : 'Unterzeichnen'}
            </a>
          </FormSignatureContainer>
        </SignatureGrid>
        <LargeModal open={openModal}>
          <SignatureContainer>
            <h2>Hier unterschreiben</h2>
            <Signature grabSignature={this.handleSignatureConfirm} clever={clever}/>
            <TranspBtn onClick={() => this.setState({ openModal: false })}>
              Schließen
            </TranspBtn>
          </SignatureContainer>
        </LargeModal>
        <CustomStartBtn centered onClick={this.submitForm}>
          {submitText}
        </CustomStartBtn>
        <FeedbackText error visible={showErrors}>
          Bitte füllen Sie alle Felder sinngemäß aus.
        </FeedbackText>
        <FeedbackText error visible={showProcessingErrors}>
          Es ist ein interner Fehler aufgetreten. Bitte versuchen Sie es später
          noch einmal oder wenden Sie sich an den {this.props.clever? "CLEVER" : "Benu"}-Kundendienst unter
          kontakt@clever-bestattung.at
        </FeedbackText>
      </Container>
    )
  }
}

const Container = styled.div`
  min-height: 100vh;
  div + p {
    margin-top: 15px;
  }
`

const CustomStartBtn = styled(StartBtn)`
  background: ${(props) => (colorStyles.buttonBg)};
  background: ${(props) => (props.disabled ? colorStyles.buttonDisabled : colorStyles.buttonBg)}
`

const WarrantTextInput = styled(TInput)`
  width: 100%;
  margin: 0;
  padding: 15px 30px;
  background: ${(props) => (colorStyles.bg)};
  border-color: ${(props) => (props.valid ? colorStyles.border : colorStyles.borderError )};
`

const Grid = styled.div`
  margin-bottom: 7.5px;
  display: grid;
  grid-template-areas:
    'f1 . '
    'f2 f3'
    'f4 f5'
    'f6 f7'
    'f8 f8'
    'f9 f9';
  grid-gap: 15px;
  div:first-child {
    grid-area: f1;
  }
  input:nth-child(2) {
    grid-area: f2;
  }
  input:nth-child(3) {
    grid-area: f3;
  }
  div:nth-child(4) {
    grid-area: f4;
  }
  input:nth-child(5) {
    grid-area: f5;
  }
  input:nth-child(6) {
    grid-area: f6;
  }
  input:nth-child(7) {
    grid-area: f7;
  }
  div:nth-child(8) {
    grid-area: f8;
  }
  input:nth-child(9) {
    grid-area: f9;
  }
  ${media.tablet`
    grid-template-areas:
      'f1'
      'f2'
      'f3'
      'f4'
      'f5'
      'f6'
      'f7'
      'f8'
      'f9';
  `}
`

const GridBottom = styled.div`
  margin-bottom: 7.5px;
  display: grid;
  grid-template-areas:
    'f1 .'
    'f2 f3'
    'f4 f5'
    'f6 f6';
  grid-gap: 15px;
  div:first-child {
    grid-area: f1;
  }
  input:nth-child(2) {
    grid-area: f2;
  }
  input:nth-child(3) {
    grid-area: f3;
  }
  input:nth-child(4) {
    grid-area: f4;
  }
  input:nth-child(5) {
    grid-area: f5;
  }
  input:nth-child(6) {
    grid-area: f6;
  }
  ${media.tablet`
    grid-template-areas:
      'f1'
      'f2'
      'f3'
      'f4'
      'f5'
      'f6';
  `}
`

const SignatureGrid = styled.div`
  display: grid;
  grid-gap: 15px;
  grid-template-areas:
    'f1 f2'
    'f3 f3';
  div:last-child {
    grid-area: f3;
  }
  ${media.tablet`
    grid-template-areas:
      'f1'
      'f2'
      'f3';
  `}
`

const FormSignatureContainer = styled.div`
  width: 100%;
  margin-bottom: 15px;
  padding: 45px 15px;
  border-bottom: 5px solid;
  background: ${(props) => (colorStyles.bg)};
  border-color: ${(props) => (props.valid ? colorStyles.border : colorStyles.borderError )};
  a {
    display: block;
    margin: auto;
    text-align: center;
    text-decoration: underline;
    ${(props) => props.signed && 'margin-top: 15px;'}
  }
  img {
    display: block;
    width: 95%;
    max-width: 450px;
    max-height: 250px;
    margin: auto;
  }
  ${(props) => props.signed && 'padding: 15px;'}
`
FormSignatureContainer.defaultProps = {
  valid: true
}

const SignatureContainer = styled.div`
  padding: 15px 30px;
  text-align: center;
  & > * {
    margin-bottom: 15px;
  }
  & > *:last-child {
    margin-bottom: 0;
  }
`

let colorStyles = {
  'border': '#a7c9cd',
  'borderError': '#974353',
  'bg': '#d5e4e6',
  'buttonBg': '#974353',
  'buttonDisabled': '#C6A3A9'
}

export default withRouter(WarrantForm)



// WEBPACK FOOTER //
// ./src/components/organisms/warrant/WarrantForm.tsx